<template>
  <transition name="toast" appear>
    <div 
      v-if="visible"
      :class="[
        'fixed top-5 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 text-white text-sm font-medium max-w-xs w-full mx-4 text-center shadow-lg transition-all duration-300',
        toastClasses
      ]"
      @click="hide"
    >
      <div class="flex items-center justify-center space-x-2">
        <svg v-if="type === 'success'" class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
        </svg>
        <svg v-else-if="type === 'error'" class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
        <svg v-else-if="type === 'warning'" class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
        </svg>
        <svg v-else class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
        </svg>
        <span>{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { ref, computed, watch } from 'vue'

export default {
  name: 'MobileToast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['success', 'error', 'warning', 'info'].includes(value)
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  emits: ['update:visible', 'hide'],
  setup(props, { emit }) {
    const timer = ref(null)
    
    const toastClasses = computed(() => ({
      'bg-success rounded-lg': props.type === 'success',
      'bg-error rounded-lg': props.type === 'error',
      'bg-warning rounded-lg': props.type === 'warning',
      'bg-primary rounded-lg': props.type === 'info'
    }))
    
    const hide = () => {
      emit('update:visible', false)
      emit('hide')
    }
    
    const startTimer = () => {
      if (timer.value) {
        clearTimeout(timer.value)
      }
      if (props.duration > 0) {
        timer.value = setTimeout(() => {
          hide()
        }, props.duration)
      }
    }
    
    watch(() => props.visible, (newVal) => {
      if (newVal) {
        startTimer()
      } else {
        if (timer.value) {
          clearTimeout(timer.value)
          timer.value = null
        }
      }
    }, { immediate: true })
    
    return {
      toastClasses,
      hide
    }
  }
}
</script>

<style scoped>
.toast-enter-active {
  transition: all 0.3s ease-out;
}

.toast-leave-active {
  transition: all 0.3s ease-in;
}

.toast-enter-from {
  transform: translate(-50%, -100%);
  opacity: 0;
}

.toast-leave-to {
  transform: translate(-50%, -100%);
  opacity: 0;
}
</style>